import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SelectedProjectFragment = { __typename?: 'Project', id: string, archivedAt?: string | null, deletedAt?: string | null, fileCount: number, insertedAt: string, isWorkfront?: boolean | null, memberCount?: number | null, mountedStorageStatus?: Types.MountedStorageStatus | null, name: string, private: boolean, storage: number, updatedAt?: string | null, images: { __typename?: 'Images', image64?: string | null }, workspace?: { __typename?: 'Workspace', id: string, name: string, images?: { __typename?: 'Images', image64?: string | null } | null } | null };

export const SelectedProject = /*#__PURE__*/ gql`
    fragment SelectedProject on Project {
  id
  archivedAt
  deletedAt
  fileCount
  images {
    image64
  }
  insertedAt
  isWorkfront
  memberCount
  mountedStorageStatus
  name
  private
  storage
  updatedAt
  workspace {
    id
    name
    images {
      image64
    }
  }
}
    ` as unknown as DocumentNode<SelectedProjectFragment, unknown>;

        

        
export const useSelectedProjectFragment = (
  input: string | Omit<UseFragmentOptions<SelectedProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<SelectedProjectFragment>({
    fragment: SelectedProject,
    fragmentName: 'SelectedProject',
    ...options,
  });
};
  
        